// Z-Menu functionality - Simple version without imports
(function() {
  'use strict';
  
  const ACTIVATE_DELAY = 150;
  const DEACTIVATE_DELAY = 200;
  let activeItem = null;
  let activateTimeout = null;
  let deactivateTimeout = null;
  let isScrolled = false;
  let headerColorTimeout = null;

  // Simple debounce function
  function debounce(func, wait) {
    return function(...args) {
      clearTimeout(activateTimeout);
      activateTimeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  // Simple document ready function
  function onDocumentReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  // Check if user has scrolled from top
  function checkScrollPosition() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const newIsScrolled = scrollTop > 0;
    
    if (newIsScrolled !== isScrolled) {
      isScrolled = newIsScrolled;
      updateHeaderStickyAttribute();
    }
  }

  // Update header sticky attribute
  function updateHeaderStickyAttribute() {
    const headerSection = document.querySelector('.z-header-section');
    if (headerSection) {
      headerSection.setAttribute('data-header-sticky', isScrolled.toString());
    }
  }

  // Handle header color transitions with delay
  function setHeaderColorState(state) {
    const headerSection = document.querySelector('.z-header-section');
    if (headerSection) {
      clearTimeout(headerColorTimeout);
      
      if (state === 'hover') {
        // Immediately show hover colors
        headerSection.setAttribute('data-header-hover', 'true');
      } else {
        // Delay returning to transparent/default
        headerColorTimeout = setTimeout(() => {
          headerSection.removeAttribute('data-header-hover');
        }, DEACTIVATE_DELAY);
      }
    }
  }

  // Initialize z-menu functionality
  function initializeZMenu() {
    const menuContainers = document.querySelectorAll('.z-desk-menu');
    
    menuContainers.forEach(function(container) {
      const menuItems = container.querySelectorAll('.z-first-link');
      
      menuItems.forEach(function(item) {
        if (item.dataset.zMenuBound === 'true') return;
        item.dataset.zMenuBound = 'true';

        // Mouse events
        item.addEventListener('mouseenter', handleMouseEnter);
        item.addEventListener('mouseleave', handleMouseLeave);
        
        // Focus events for accessibility
        const link = item.querySelector('.z-first-a');
        if (link) {
          link.addEventListener('focus', handleFocus);
          link.addEventListener('blur', handleBlur);
        }
      });
    });
  }

  // Handle mouse enter event
  function handleMouseEnter(event) {
    clearTimeout(deactivateTimeout);
    debouncedActivate(event);
    setHeaderColorState('hover');
  }

  // Handle mouse leave event
  function handleMouseLeave(event) {
    clearTimeout(activateTimeout);
    debouncedDeactivate();
    setHeaderColorState('leave');
  }

  // Handle focus event
  function handleFocus(event) {
    clearTimeout(deactivateTimeout);
    debouncedActivate(event);
  }

  // Handle blur event
  function handleBlur(event) {
    // Check if the focus is moving to a child element within the same menu item
    const relatedTarget = event.relatedTarget;
    if (!(event.target instanceof Element)) return;
    const currentItem = event.target.closest('.z-first-link');
    
    if (relatedTarget && currentItem && relatedTarget instanceof Node && currentItem.contains(relatedTarget)) {
      return; // Don't deactivate if focus is moving within the same menu item
    }
    
    clearTimeout(activateTimeout);
    debouncedDeactivate();
  }

  // Activate menu item
  function activate(event) {
    if (!(event.target instanceof Element)) return;
    const target = event.target.closest('.z-first-link');
    if (!target || target === activeItem) return;

    // Deactivate previous item
    if (activeItem) {
      deactivateItem(activeItem);
    }

    // Activate new item
    activeItem = target;
    activateItem(target);
  }

  // Deactivate current menu item
  function deactivate() {
    if (activeItem) {
      deactivateItem(activeItem);
      activeItem = null;
    }
  }

  // Activate a specific menu item
  function activateItem(item) {
    item.setAttribute('data-active', '');
    item.setAttribute('aria-expanded', 'true');
    
    const submenu = item.querySelector('.z-mega-sub-wrap');
    if (submenu && submenu instanceof HTMLElement) {
      submenu.style.visibility = 'visible';
      submenu.style.opacity = '1';
      submenu.setAttribute('aria-hidden', 'false');
    }
  }

  // Deactivate a specific menu item
  function deactivateItem(item) {
    item.removeAttribute('data-active');
    item.setAttribute('aria-expanded', 'false');
    
    const submenu = item.querySelector('.z-mega-sub-wrap');
    if (submenu && submenu instanceof HTMLElement) {
      submenu.style.visibility = 'hidden';
      submenu.style.opacity = '0';
      submenu.setAttribute('aria-hidden', 'true');
    }
  }

  // Debounced versions of activate and deactivate
  const debouncedActivate = debounce(activate, ACTIVATE_DELAY);
  const debouncedDeactivate = debounce(deactivate, DEACTIVATE_DELAY);

  // Initialize when document is ready (guard: script may appear in more than one section)
  onDocumentReady(function() {
    if (window.__fsZMenuInit) return;
    window.__fsZMenuInit = true;

    initializeZMenu();

    checkScrollPosition();
    window.addEventListener('scroll', checkScrollPosition);
  });

})();

// fix for mobile country selector (once; z-menu.js may load from multiple sections)
if (!window.__fsZMenuLocalizationClicks) {
  window.__fsZMenuLocalizationClicks = true;
  document.addEventListener('click', function(event) {
    const backButton = event.target.closest('.menu-drawer__back-button');
    if (backButton) {
      const drawer = document.getElementById('drawer-localization');
      if (drawer && drawer.hasAttribute('open')) {
        drawer.removeAttribute('open');
      }
    }
  });
  document.addEventListener('click', function(event) {
    const closeButton = event.target.closest('.menu-drawer__close-button');
    if (closeButton) {
      const drawer = document.getElementById('drawer-localization');
      if (drawer && drawer.hasAttribute('open')) {
        drawer.removeAttribute('open');
      }
      document.body.classList.remove('js-m-nav');
    }
  });
}
